import { useTranslations } from 'next-intl'
import { tw } from 'utils/classnames'

import { Tooltip } from '../tooltip'

export function ProductShareTitle() {
  const t = useTranslations('prod.product_description_page.share_earn')

  return (
    <>
      <div className="mb-2 text-[18px] font-bold leading-7">{t('title')}</div>
      <div className={tw('mb-2', 'transition-all')}>
        <span className="inline-block">
          {t.rich('description', {
            percent: '25%',
            a: str => (
              <Tooltip
                hideArrow={false}
                className="z-[1] py-0"
                arrowClassName="bg-[#0F7B59] border-[#0F7B59] fill-[#0F7B59]"
                value={
                  <div
                    className={tw(
                      'text-cf-white rounded-4 max-w-[325px] overflow-auto bg-[#0F7B59] p-4',
                    )}
                  >
                    {t.rich('description_tip', { br: () => <br /> })}
                  </div>
                }
              >
                <div
                  tabIndex={0}
                  className="text-cf-link inline-block underline hover:cursor-pointer"
                >
                  {str}
                </div>
              </Tooltip>
            ),
          })}
        </span>
      </div>
    </>
  )
}
